import { parallaxImages } from "../common/animations/parrallaxImages.js";

// gsap animations for callout-banner block
const gsapCalloutBannerAnimations = () => {
	const wrapper = document.querySelectorAll(".callout-banner");

	if (!wrapper.length) return;

	// Animate callout-banner wrapper elements
	const animateElements = () => {
		wrapper.forEach((wrapper) => {
			const bannerWrapper = wrapper.querySelector(".callout-banner__wrapper");
			const bannerContainer = wrapper.querySelector(".callout-banner__container");
			
			// Get corner color from data attribute
			const cornerColor = wrapper.dataset.cornerColor || "#ffffff";

			if (bannerWrapper && bannerContainer) {
				// Store the natural height before collapsing for proper trigger calculation
				const naturalHeight = bannerWrapper.offsetHeight;
				
				// Give the main wrapper a min-height so ScrollTrigger can calculate center properly
				gsap.set(wrapper, {
					minHeight: naturalHeight + "px",
				});
				
				// Set initial state - collapsed and hidden
				gsap.set(bannerWrapper, {
					height: 0,
					overflow: "hidden",
				});
				
				gsap.set(bannerContainer, {
					opacity: 0,
					y: 0,
				});

				// Create ScrollTrigger for one-time slide out animation
				ScrollTrigger.create({
					trigger: wrapper,
					start: "center bottom", // When center of component hits bottom of screen (now calculated from min-height)
					//markers: true, // Debug markers
					once: true, // Only trigger once - stays visible forever after animation
					onEnter: () => {
						// One-time expand and slide out animation
						const tl = gsap.timeline();
						tl.to(bannerWrapper, {
							height: "auto",
							duration: 1,
							ease: "power2.out",
						})
						.to(bannerContainer, {
							opacity: 1,
							duration: 0.8,
							ease: "power2.out",
						}, 0.2)
						// Add red background fade-in when slide down completes
						.to(wrapper, {
							backgroundColor: cornerColor || "#ffffff",
							duration: 0.6,
							ease: "power2.out",
						}, "-=0.2"); // Start slightly before the slide completes for smooth transition
					},
				});
			}
		});
	};

	animateElements();
	parallaxImages(wrapper);
};

// Initialize everything when DOM is ready
if (document.readyState !== "loading") {
	gsapCalloutBannerAnimations();
} else {
	document.addEventListener("DOMContentLoaded", () => {
		gsapCalloutBannerAnimations();
	});
}